import { IconButton } from '@mui/material';
import { X } from 'lucide-react';
import { closeSnackbar, SnackbarKey } from 'notistack';
import { useIntl } from 'react-intl';

/**
 * Close button rendered as the `action` of warning and error snackbars so the
 * user can dismiss these longer-lived notifications without waiting for the
 * auto-hide timeout. Inherits the snackbar's text color so it stays legible on
 * both the warning and error backgrounds.
 */
export default function SnackbarCloseButton({
    snackbarKey,
}: {
    snackbarKey: SnackbarKey;
}) {
    const intl = useIntl();
    return (
        <IconButton
            size="small"
            aria-label={intl.formatMessage({ id: 'snackbar.dismiss' })}
            onClick={() => closeSnackbar(snackbarKey)}
            sx={{ color: 'inherit' }}
        >
            <X size={18} />
        </IconButton>
    );
}
